//#region IMPORTS
import {
  setOrderParams,
  fetchOrdersAsync,
  fetchApprovableOrdersAsync,
} from "./ordersSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { ORDERSTATUS, ORDERTYPE } from "../../models/order";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import OrdersContainer from "../../components/orders/OrdersContainer";
//#endregion

//#region INTERFACE
interface Props {
  title: string;
}
//#endregion

export default function OrdersApprovePage({ title }: Props) {
  //#region SETUP
  const { code } = useParams<{ code: string }>();

  // Redux
  const dispatch = useAppDispatch();
  const { orders_loaded } = useAppSelector((state) => state.orders);
  //#endregion

  //#region LOGIC
  // Set page specific filters
  useEffect(() => {
    dispatch(
      setOrderParams({
        limit: 10000,
        sort: JSON.stringify({ column: "order_date", order: "desc" }),
        order_status: ORDERSTATUS.pending,
        order_type: ORDERTYPE.backorder,
        include_sub_orders: 1,
      })
    );
  }, [dispatch]);

  // Load orders
  useEffect(() => {
    const fetchOnload = async () => {
      if (!orders_loaded) {
        await dispatch(fetchOrdersAsync());
        await dispatch(fetchApprovableOrdersAsync());
      }
    };
    fetchOnload();
  }, [orders_loaded, dispatch]);
  //#endregion

  //#region RENDER
  return (
    <OrdersContainer
      hideOrderstatusFilter
      hideOrdertypeFilter
      title={code ? `${title} for project ${code}` : title}
    />
  );
  //#endregion
}
